import { createContext } from "react";

const ScrollContext = createContext();

export default ScrollContext;
